/**
 * セレクタが存在するかどうかをチェックする関数
 * @param {*} selector 
 * @returns 
 */
export function isExist(selector) {
    return document.querySelector(selector) !== null
}